import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type LinkReplacementPayload = {
  intervention_id: number;
  vehicle_tyre_replacement_id: number;
};

export const useLinkReplacementMutation = () =>
  useTypedMutation({
    mutationFn: (payload: LinkReplacementPayload) => ApiInstance.post("/vehicle_tyre_replacements/link", payload, ENV.appointmentBaseURL),
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length || !appointment.car?.tyres?.length) return;

      const tyreIdx = appointment.car.tyres.findIndex(t => t.replacements?.some(r => r.id === payload.vehicle_tyre_replacement_id));
      if (tyreIdx < 0 || !appointment.car.tyres[tyreIdx].replacements?.length) return;

      const replacementIdx = appointment.car.tyres[tyreIdx].replacements.findIndex(r => r.id === payload.vehicle_tyre_replacement_id);
      if (replacementIdx < 0) return;

      const interventionIdx = appointment.interventions.findIndex(i => i.id === payload.intervention_id);
      if (interventionIdx < 0) return;

      const replacement = { ...appointment.car.tyres[tyreIdx].replacements[replacementIdx], intervention_id: payload.intervention_id };
      const tyres = appointment.car.tyres.with(tyreIdx, {
        ...appointment.car.tyres[tyreIdx],
        replacements: appointment.car.tyres[tyreIdx].replacements.with(replacementIdx, replacement)
      });

      let interventions = appointment.interventions;
      if (!interventions[interventionIdx].replacements?.some(r => r.id === payload.vehicle_tyre_replacement_id))
        interventions = interventions.with(interventionIdx, {
          ...appointment.interventions[interventionIdx],
          replacements: (appointment.interventions[interventionIdx].replacements ?? []).concat(replacement)
        });

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, tyres }, interventions });
    }
  });
